/**
 * Build-time feature flags. This is the only module that reads progress-bar
 * flags from the environment (contribution progress parity, Rule 5); components
 * import `flags` from here instead of reading `import.meta.env` directly.
 */
export interface FeatureFlags {
  /**
   * `VITE_LEVEL_TRACKER === 'true'` renders the level tracker for milestone goals.
   * Any other value falls back to the milestone ladder. Kill switch for CAX-3900.
   */
  levelTracker: boolean
}

export const flags: FeatureFlags = {
  levelTracker: import.meta.env.VITE_LEVEL_TRACKER === 'true',
}
